<template>
	<div class="app-header">
		<template v-if="$route.meta.origin">
			<AppImage
				class="app-header__logo"
				title="upmood-logo"
				:src="require('@/assets/img/upmood-logo.svg')"
			/>
			<AppIcon
				class="app-header__arrow"
				icon-name="arrowLeft"
				@click="$router.push({ name: $route.meta.origin[0].name })"
			/>
			<h3 class="app-header__name">{{ title }}</h3>
		</template>

		<template v-else>
			<h3 class="app-header__name">{{ title }}</h3>

			<UserNotification>
				<AppIcon
					class="app-header__icon"
					icon-name="notification"
				/>
			</UserNotification>

			<div class="app-header__avatar">
				<AppImage
					:src="require('@/assets/img/default-avatar.png')"
					title="avatar"
					class="avatar"
					@click="showUserMenu = !showUserMenu"
				/>

				<p
					v-if="showUserMenu"
					class="app-header__logout"
					@click="logout()"
					v-on-clickaway="closeUserMenu"
				>
					Logout
				</p>
			</div>
		</template>

	</div>
</template>

<script>
import UserNotification from '@/components/auth/UserNotification.vue'

export default {
	components: {
		UserNotification
	},

	data () {
		return {
			showUserMenu: false
		}
	},

	computed: {
		title () {
			if (this.$route.meta) {
				return this.$route.meta.title || ''
			}

			return String(this.$route.name)
		}
	},

	methods: {
		logout () {
			this.$store.commit('LOG_OUT')
		},

		closeUserMenu () {
			this.showUserMenu = false
		}
	}
}
</script>

<style lang="scss" scoped>
.app-header {
	color: $default;
	padding: 10px 20px;
	display: flex;
	align-items: center;
	font-family: inherit;
	border-bottom: 1px solid lighten($default-light, 12%);
	z-index: 9;

	&__name {
		flex: 1 1 auto;
		font-weight: bold;
	}

	&__icon, &__arrow {
		margin: 0 1em;
		cursor: pointer;
	}

	&__icon {
		width: 1.5em;
		height: 1.5em;
		position: relative;
	}

	&__avatar {
		position: relative;
		margin-left: 1em;

		.avatar {
			cursor: pointer;
			border-radius: 50%;
			width: 2em;
			height: 2em;
			background-size: cover;
		}
	}

	&__arrow {
		width: 1em;
		height: 1em;
	}

	&__logo {
		width: 30px;
		height: 30px;
		margin-right: 2em;
	}

	&__logout {
		position: absolute;
		top: 100%;
		right: 0;
		margin-top: 10px;
		background-color: #fff;
		padding: 10px 20px;
		font-weight: 600;
		color: $dark;
		cursor: pointer;
		border: 1px solid $light;
		border-radius: 5px;
		z-index: 999;

		&:after {
			position: absolute;
			content: "";
			right: .5em;
			top: -6px;
			border: 1px solid;
			border-color: $light  $light transparent transparent;
			display:inline-block;
			height: 10px;
			width: 10px;
			background-color: #fff;
			transform: rotateZ(-45deg);
			pointer-events: none;
			z-index: 999;
		}

		&:hover {
			color: $primary;
			border-color: $primary;

			&:after {
				border-color: $primary $primary transparent transparent;
			}
		}
	}
}
</style>
